import React from 'react';

import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/NavigationBar.css';

interface NavigationIconProps {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
  active?: boolean;
}

const NavigationIcon: React.FC<NavigationIconProps> = ({ icon, label, onClick, active = false }) => (
  <div className={`nav-item ${active ? 'active' : ''}`} onClick={onClick}>
    <div className="nav-icon">{icon}</div>
    <div className="nav-label">{label}</div>
  </div>
);

export const NavigationBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleNav = (path: string) => {
    if (location.pathname !== path) {
      navigate(path);
    }
  };

  return (
    <footer className="app-footer">
      <NavigationIcon 
        icon={<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/></svg>}
        label="Задания" 
        active={location.pathname === '/tasks'} 
        onClick={() => handleNav('/tasks')} 
      />
      <NavigationIcon 
        icon={<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z"/></svg>}
        label="Рулетка" 
        active={location.pathname === '/roulette'} 
        onClick={() => handleNav('/roulette')} 
      />
      <NavigationIcon 
        icon={<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M11.5 9C10.12 9 9 10.12 9 11.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5S12.88 9 11.5 9zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.21 14.21l-2.91-2.91c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7 16 9.01 16 11.5c0 .88-.26 1.69-.7 2.39l2.91 2.9-1.42 1.42z"/></svg>}
        label="Тапать" 
        active={location.pathname === '/' || location.pathname === '/tap'} 
        onClick={() => handleNav('/')} 
      />
      <NavigationIcon 
        icon={<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>}
        label="Друзья" 
        active={location.pathname === '/friends'} 
        onClick={() => handleNav('/friends')} 
      />
      <NavigationIcon 
        icon={<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>}
        label="Кошелек" 
        active={location.pathname === '/wallet'} 
        onClick={() => handleNav('/wallet')} 
      />
    </footer>
  );
};